import {
  APP_OPENSIDEBAR,
  APP_UPDATEBREADCRUMB,
  APP_FIREBASEUSER,
  APP_PWASYNCINPROGRESS,
  APP_PWASYNCSTATUS,
  APP_PWAEVENTSALL,
  APP_PWAINSTALLPROMPT,
} from "store/actionTypes/app";

import { RESET } from "store/actionTypes/login";

// constants
const initialState = {
  isSidebarOpen: !(window.screen.width > 767),
  breadcrumb: [],
  firebaseUser: null,
  pwaSyncInprogress: false,
  pwaSyncStatus: null,
  pwaIndexDBEvents: null,
  pwaInstallPrompt: null,
};

// reducer
const appDetails = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return { ...state, ...initialState };
    case APP_OPENSIDEBAR:
      return { ...state, isSidebarOpen: action.payload };
    case APP_UPDATEBREADCRUMB:
      return { ...state, breadcrumb: action.payload };
    case APP_FIREBASEUSER:
      return { ...state, firebaseUser: action.payload };
    case APP_PWASYNCINPROGRESS:
      return { ...state, pwaSyncInprogress: action.payload };
    case APP_PWASYNCSTATUS:
      return { ...state, pwaSyncStatus: action.payload };
    case APP_PWAEVENTSALL:
      return { ...state, pwaIndexDBEvents: action.payload };
    case APP_PWAINSTALLPROMPT:
      return { ...state, pwaInstallPrompt: action.payload };
    default:
      return state;
  }
};

export default appDetails;
